import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Support reading config from CRA env vars or a runtime-injected `window.__env` object.
const getRuntimeEnv = () => {
	if (typeof window === 'undefined') return {} as Record<string, string>;
	return (window as any).__env || {};
};

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || getRuntimeEnv().REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || getRuntimeEnv().REACT_APP_SUPABASE_ANON_KEY;

let _supabase: any;
if (!supabaseUrl || !supabaseAnonKey) {
	// Export a helpful stub that throws on use and logs a clear error to the console.
	const message = `Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment or provide them at runtime via window.__env.`;
	// eslint-disable-next-line no-console
	console.error(message);

	const handler: ProxyHandler<any> = {
		get() {
			throw new Error(message);
		},
		apply() {
			throw new Error(message);
		},
	};

	// Provide a proxy so any access throws with a clear message instead of the low-level createClient error.
	_supabase = new Proxy(() => {}, handler);
} else {
	_supabase = createClient(supabaseUrl, supabaseAnonKey);
}

export const supabase: any = _supabase;
